// extracted by mini-css-extract-plugin
export default {"errorContainer":"errorPage_errorContainer__PWsF4"};